import { render, staticRenderFns } from "./PNRisks.vue?vue&type=template&id=300b997a"
import script from "./PNRisks.vue?vue&type=script&lang=js"
export * from "./PNRisks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports